export default __webpack_public_path__ + "fdd87ad5762e19cb5caafa0f6279a4db.svg";